import { useState, useEffect } from "react";
import api from "../api/api"; // Adjust this import path as needed

const useSellerIdByName = (inputSellerName) => {
  const [sellerId, setSellerId] = useState(null);
  const [sellerName, setSellerName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSellerId = async () => {
      try {
        setLoading(true);
        
        // Clear any existing cached data for this seller name
        const cachedSellerName = localStorage.getItem('sellerName');
        if (cachedSellerName && cachedSellerName !== inputSellerName) {
          localStorage.removeItem('sellerId');
          localStorage.removeItem('sellerName');
          sessionStorage.removeItem('sellerId');
          sessionStorage.removeItem('sellerName');
        }
        
        // Try to resolve by name first
        const { data } = await api.get(`/search-seller?name=${inputSellerName}`);
        if (data?.seller?.id && data?.seller?.name) {
          setSellerId(data.seller.id);
          setSellerName(data.seller.name);
          sessionStorage.setItem('sellerId', data.seller.id);
          sessionStorage.setItem('sellerName', data.seller.name);
          localStorage.setItem('sellerId', data.seller.id);
          localStorage.setItem('sellerName', data.seller.name);
          setLoading(false);
          return;
        }
        
        // If not found and input is lowercase, try uppercase version
        if (inputSellerName === inputSellerName.toLowerCase()) {
          const { data: upperData } = await api.get(`/search-seller?name=${inputSellerName.toUpperCase()}`);
          if (upperData?.seller?.id && upperData?.seller?.name) {
            setSellerId(upperData.seller.id);
            setSellerName(upperData.seller.name);
            sessionStorage.setItem('sellerId', upperData.seller.id);
            sessionStorage.setItem('sellerName', upperData.seller.name);
            localStorage.setItem('sellerId', upperData.seller.id);
            localStorage.setItem('sellerName', upperData.seller.name);
            setLoading(false);
            return;
          }
        }
        
        // If not found by name, try by id
        const byId = await api.get(`/search-seller-by-id?id=${inputSellerName}`);
        if (byId?.data?.seller?.id && byId?.data?.seller?.name) {
          setSellerId(byId.data.seller.id);
          setSellerName(byId.data.seller.name);
          sessionStorage.setItem('sellerId', byId.data.seller.id);
          sessionStorage.setItem('sellerName', byId.data.seller.name);
          localStorage.setItem('sellerId', byId.data.seller.id);
          localStorage.setItem('sellerName', byId.data.seller.name);
        }
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch seller ID");
        setLoading(false);
      }
    };

    if (inputSellerName) {
      fetchSellerId();
    }
  }, [inputSellerName]);

  return { sellerName, sellerId, loading, error };
};

export default useSellerIdByName;
